/**
 * Created by shubham on 25/11/18.
 */

import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent, SelectApplicationsDialogComponent } from '../../../dialog/dialog.component';


@Component({
    selector: 'view-business-unit-for-user',
    template: require('./view-business-unit.component.html')
})
export class ViewBusinessUnitForUserComponent {

    dialogRef;
    userDetails: any;
    id: any;
    businessUnitDetails = [];
    applications = [];
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    isDisabled = true;
    admins = [];
    settings = {};
    selectedItems = [];
    applicationData = [];

    constructor(private router: Router,private route: ActivatedRoute, private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder) {

        this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if(this.isServiceOwner){
            this.getBusinessUnitDetailsById(this.id);
        }
    }

    public getBusinessUnitDetailsById(id){
        this.httpService.getRequest('partnerOperationsApi/v1/businessUnitDetailsForPartner/'+ id).subscribe(
            res => { this.saveBusinessUnitDetails(res) },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveBusinessUnitDetails(res) {
        if(res){
            this.businessUnitDetails = res;
            if(this.businessUnitDetails['applications']){
                this.applications = this.businessUnitDetails['applications'];
                for(let appIndex in this.applications){
                    if(!this.applications[appIndex]['message']){
                        this.applications[appIndex]['message'] = "";
                    }
                }
            }
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail'){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    public requestNewApplication(businessUnitId) {
        this.httpService.getRequest('applicationOperationApi/v1/getUnsubscribedApplicationsForPartner/'+businessUnitId).subscribe(
            res => { this.requestNewApplicationResponse(res, businessUnitId); },
            err => { this.httpService.onEnd(); }
        );
    }
    requestNewApplicationResponse(res, businessUnitId) {
        if(res && res.items){
            this.applicationData = res.items;
            this.dialogRef = this.dialog.open(SelectApplicationsDialogComponent);
            this.dialogRef.componentInstance.applications = this.applicationData;
            this.dialogRef.componentInstance.businessUnitId = businessUnitId;
            this.dialogRef.afterClosed().subscribe(result => {
                if(result){
                    this.saveApplications(result);
                }
            });
        }
        this.httpService.onEnd();
    }
    saveApplications(result){
        this.httpService.postRequest(result,'applicationOperationApi/v1/subscribeApplications').subscribe(
            res => { this.saveBusinessUnitDetails(res); },
            err => { this.httpService.onEnd(); }
        );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/view-business-unit/view-business-unit.component.ts